import merge from 'lodash/merge';

const state = () => ({
  id: null,
  isPreview: false,
  media: [],
  previewType: null,
  previewTypeId: null,
  use_points: false
});

const actions = {
  setOffer({ commit }, offer) {
    // Initiated by api/getInitialData
    // Add the offer and include a normalized array of ids
    // of other resources related to the offer
    commit('add', offer);

    // If we ever return deals, products etc.
    // we can handle them here
  }
};

const mutations = {
  add(state, offer) {
    // Vue 3 reactivity handles this automatically
    merge(state, offer);
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations
};
